<template>
  <div class="dashboard-container">
    <side-bar />
    <div class="main-content">
      <h2>Update your profile</h2>
      <hr class="h2"/>
      <div class="container">
        <component src="https://c2hbe361.caspio.com/dp/76bfd0008e33d295fe7f4af6825b/emb" :is="'script'"></component>
      </div>
    </div>
  </div>
</template>


<script>
import SideBar from './SideBar.vue'

export default {
  name: 'UpdateProfile',
  components: {
    SideBar
  }
}
</script>